"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingKitLineDetail = void 0;
const models_1 = require("../models");
class ShippingKitLineDetail extends models_1.ShippingKitLine {
}
exports.ShippingKitLineDetail = ShippingKitLineDetail;
//# sourceMappingURL=shipping-kit-line-detail.response.js.map